// extracted by mini-css-extract-plugin
module.exports = {"icon":"ButtonIcon_icon__1Xv9z"};